import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormCheckbox, FormPanel, FormTextField } from '@eas/common-web';

export function Fields() {
  return (
    <FormPanel
      label={
        <FormattedMessage
          id="TAPIS__SYSTEM_USERS__DETAIL__PANEL_TITLE"
          defaultMessage="Základní informace"
        />
      }
    >
      <FormTextField
        name="username"
        label={
          <FormattedMessage
            id="TAPIS__SYSTEM_USERS__DETAIL__FIELD_LABEL__LAST_NAME"
            defaultMessage="Uživatelské jméno"
          />
        }
        required
      />
      <FormTextField
        name="email"
        label={
          <FormattedMessage
            id="TAPIS__SYSTEM_USERS__DETAIL__FIELD_LABEL__EMAIL"
            defaultMessage="Email"
          />
        }
        required
      />
      <FormCheckbox
        name="apiKeyHash"
        label={
          <FormattedMessage
            id="TAPIS__SYSTEM_USERS__DETAIL__FIELD_LABEL__API_KEY"
            defaultMessage="API klíč přidělen"
          />
        }
        disabled
      />
    </FormPanel>
  );
}
